@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/mixins';
@import '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils';

.cardWrapper {
  max-width: 240px;
  display: flex;
  align-self: flex-start;
}

.entityCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $spacer * 2 $spacer * 1.5;
  color: $text-default;
  font-weight: $font-weight-medium;
  transition: all 200ms ease;
  box-shadow: $shadow-default;
  border: 1px solid $divider-color;
  position: relative;
  margin-top: $spacer * 2.5;
  cursor: pointer;
  background: $surface-bg-secondary;
  border-radius: $border-radius-md;

  &:hover,
  &:focus {
    @include elevated-item-style(1.05);
  }

  .title {
    font-size: $font-size-subheader;
    line-height: $spacer * 1.5;
    text-align: center;
  }
}

.entityCardImgContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: $spacer * 1.5;
  position: relative;
  margin-top: $spacer * 1.5;
  width: 94px;
  height: 94px;

  img {
    max-height: 3rem;
    max-width: 3rem;
    z-index: 1;
  }

  .entityCardImgBg {
    border-radius: $border-radius-lg;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #1282d4;
    opacity: 0.1;
  }
}

.entityCardName {
  text-align: center;
  font-size: $font-size-subheader;
  line-height: $spacer * 1.5;
}

.poweredBy {
  margin-top: $spacer * 2.5;
  font-size: $font-size-body;
  color: $text-secondary;
  display: flex;
  align-items: center;
}

.dividerWrapper {
  overflow: hidden;
  margin-top: $spacer * 2.5;
  margin-bottom: $spacer * 0.625;

  .verticalRow {
    margin: 0 auto;
    width: 1px;
    height: 40%;
    border-left: solid $border-width $divider-color;
  }

  .or {
    @include typography-level-to-styles(typography-config(), subheading-2);
    text-align: center;
    line-height: 22px;
    margin: $spacer * 1.25 0;
  }
}
